import React from 'react';
import './skeletonCss.scss';

type Props = Readonly<{
  fromLinksModal?: boolean;
}>;

export default function AudioSkeleton({}: Props) {
  const skeletonItems = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
  return (
    <div
      className='audio-skeleton-container d-flex flex-row flex-wrap'
      data-testid='audio-skeleton'
    >
      {skeletonItems.map((id) => (
        <div key={id} className='audio-skeleton-box' />
      ))}
    </div>
  );
}
